/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateStoredCryptoLinkRequest
 */
export interface CreateStoredCryptoLinkRequest {
  /**
   * Произвольный JSON-payload, сохраняемый в БД
   * @type {{ [key: string]: any; }}
   * @memberof CreateStoredCryptoLinkRequest
   */
  payload: { [key: string]: any }
  /**
   * Срок жизни ссылки в секундах (60–2592000); по умолчанию 3600
   * @type {number}
   * @memberof CreateStoredCryptoLinkRequest
   */
  ttlSeconds?: number | null
}

/**
 * Check if a given object implements the CreateStoredCryptoLinkRequest interface.
 */
export function instanceOfCreateStoredCryptoLinkRequest(
  value: object
): value is CreateStoredCryptoLinkRequest {
  if (!('payload' in value) || value['payload'] === undefined) return false
  return true
}

export function CreateStoredCryptoLinkRequestFromJSON(
  json: any
): CreateStoredCryptoLinkRequest {
  return CreateStoredCryptoLinkRequestFromJSONTyped(json, false)
}

export function CreateStoredCryptoLinkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateStoredCryptoLinkRequest {
  if (json == null) {
    return json
  }
  return {
    payload: json['payload'],
    ttlSeconds: json['ttlSeconds'] == null ? undefined : json['ttlSeconds'],
  }
}

export function CreateStoredCryptoLinkRequestToJSON(
  value?: CreateStoredCryptoLinkRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    payload: value['payload'],
    ttlSeconds: value['ttlSeconds'],
  }
}
